"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentManagementView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _msalReact = require("@azure/msal-react");
var _material = require("@mui/material");
var _useGetBlobsQuery2 = require("api/useGetBlobsQuery");
var _Alerts = require("components/shared/Alerts/Alerts");
var _usePollingSerchStatus = require("hooks/usePollingSerchStatus");
var _constants = require("util/constants");
var _TeamsLogo = _interopRequireDefault(require("../../assets/img/TeamsLogo.png"));
require("../../css/documentManagement.css");
var _DocumentsGrid = _interopRequireDefault(require("./DocumentsGrid"));
var _TeamsIntegrationModal = require("@/components/DocumentManagementView/modals/TeamsIntegrationModal");
var _BackgroundContainer = _interopRequireDefault(require("@/components/shared/BackgroundTasks/BackgroundContainer"));
var _DeleteModal = require("@/components/shared/Modal/DeleteModal");
var _EditModal = require("@/components/shared/Modal/EditModal");
var _MoveModal = require("@/components/shared/Modal/MoveModal");
var _OverrideModal = require("@/components/shared/Modal/OverrideModal");
var _UploadFile = require("@/components/shared/Modal/UploadFile");
var _BackgroundContext = require("@/context/BackgroundContext");
var _PermissionsContext = require("@/context/PermissionsContext");
var _TeamsAndChannelsContext = require("@/context/TeamsAndChannelsContext");
var _policies = require("@/utils/policies");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var DocumentManagementView = exports.DocumentManagementView = function DocumentManagementView(_ref) {
  var _ref$teamsIntegration = _ref.teamsIntegrationFlag,
    teamsIntegrationFlag = _ref$teamsIntegration === void 0 ? true : _ref$teamsIntegration;
  var _useBackground = (0, _BackgroundContext.useBackground)(),
    getBackgroundTasks = _useBackground.getBackgroundTasks,
    removeBackgroundTask = _useBackground.removeBackgroundTask;
  var tasks = _toConsumableArray(getBackgroundTasks());
  var _usePermissions = (0, _PermissionsContext.usePermissions)(),
    hasPermission = _usePermissions.hasPermission;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    showUploadFilesModal = _useState2[0],
    setShowUploadFilesModal = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    filesToDelete = _useState4[0],
    setFilesToDelete = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    filesToMove = _useState6[0],
    setFilesToMove = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    fileToEdit = _useState8[0],
    setFileToEdit = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    fileToOverride = _useState0[0],
    setFileToOverride = _useState0[1];
  var _useState1 = (0, _react.useState)(_constants.AlertColor.Info),
    _useState10 = _slicedToArray(_useState1, 2),
    alertColor = _useState10[0],
    setAlertColor = _useState10[1];
  var _useState11 = (0, _react.useState)(""),
    _useState12 = _slicedToArray(_useState11, 2),
    alertMessage = _useState12[0],
    setAlertMessage = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedPath = _useState14[0],
    setSelectedPath = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedRows = _useState16[0],
    setSelectedRows = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    openTeamsIntegrationModal = _useState18[0],
    setOpenTeamsIntegrationModal = _useState18[1];
  var _useState19 = (0, _react.useState)(new Date(0)),
    _useState20 = _slicedToArray(_useState19, 2),
    lastRefetchTime = _useState20[0],
    setLastRefetchTime = _useState20[1];
  var _useGetBlobsQuery = (0, _useGetBlobsQuery2.useGetBlobsQuery)(),
    documents = _useGetBlobsQuery.data,
    isError = _useGetBlobsQuery.isError,
    refetch = _useGetBlobsQuery.refetch,
    isLoading = _useGetBlobsQuery.isLoading;
  var _useTeamsAndChannels = (0, _TeamsAndChannelsContext.useTeamsAndChannels)(),
    msalConfig = _useTeamsAndChannels.msalConfig;
  var _useMsal = (0, _msalReact.useMsal)(),
    instance = _useMsal.instance;
  var accounts = instance.getAllAccounts();
  var isLoggedIn = accounts.length > 0;
  (0, _usePollingSerchStatus.usePollingSearchStatus)({
    documents: documents
  });
  (0, _react.useEffect)(function () {
    if (!isError) return;
    setAlertColor(_constants.AlertColor.Error);
    setAlertMessage("Unexpected error while calling the reactor.");
  }, [isError]);
  var getTokenAndOpenModal = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return instance.loginPopup(msalConfig.loginRequest);
          case 3:
            setOpenTeamsIntegrationModal(true);
            _context.next = 11;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            console.error("Login error:", _context.t0);
            setAlertColor(_constants.AlertColor.Error);
            setAlertMessage("Authentication failed. Please try again.");
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return function getTokenAndOpenModal() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleLogin = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _msalConfig$loginRequ, account;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isLoggedIn) {
              _context2.next = 17;
              break;
            }
            _context2.prev = 1;
            account = accounts[0];
            if (msalConfig.loginRequest) {
              _context2.next = 5;
              break;
            }
            throw new Error("MSAL loginRequest configuration is missing.");
          case 5:
            _context2.next = 7;
            return instance.acquireTokenSilent(_objectSpread(_objectSpread({}, msalConfig.loginRequest), {}, {
              scopes: (_msalConfig$loginRequ = msalConfig.loginRequest.scopes) !== null && _msalConfig$loginRequ !== void 0 ? _msalConfig$loginRequ : ["User.Read"],
              account: account
            }));
          case 7:
            // Si llegamos aquí, el token es válido
            setOpenTeamsIntegrationModal(true);
            _context2.next = 15;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            console.warn("Token expired or invalid, re-authenticating...", _context2.t0);
            _context2.next = 15;
            return getTokenAndOpenModal();
          case 15:
            _context2.next = 19;
            break;
          case 17:
            _context2.next = 19;
            return getTokenAndOpenModal();
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 10]]);
    }));
    return function handleLogin() {
      return _ref3.apply(this, arguments);
    };
  }();
  var editFileLocalStorage = function editFileLocalStorage(fileEdited) {
    var localStorageValue = localStorage.getItem("doc-".concat(fileEdited.id));
    if (localStorageValue) {
      localStorage.setItem("doc-".concat(fileEdited.id), JSON.stringify(fileEdited));
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex flow-column gap-5",
    "data-testid": "doc_manag",
    alignItems: "center",
    sx: {
      background: "#F8F8F8"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      background: "white",
      width: "100%",
      padding: "24px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "title"
  }, "Document Management"), teamsIntegrationFlag && hasPermission(_policies.Permission.IMPORT_TEAMS) && /*#__PURE__*/_react["default"].createElement(_material.Button, {
    "data-testid": "teamsSyncButton",
    variant: "outlined",
    color: "purple",
    onClick: handleLogin
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    component: "img",
    src: _TeamsLogo["default"],
    alt: "teams icon",
    width: "20px",
    sx: {
      marginRight: "5px"
    }
  }), "Import Teams"))), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      margin: "24px",
      width: "calc(100% - 48px)",
      background: "white",
      borderRadius: "8px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_DocumentsGrid["default"], {
    isDocumentsLoading: isLoading,
    blobs: documents,
    callbackAddFiles: function callbackAddFiles(modalName) {
      return setShowUploadFilesModal(modalName);
    },
    callbackDeleteFile: function callbackDeleteFile(files) {
      return setFilesToDelete(files);
    },
    callbackMoveFiles: function callbackMoveFiles(files) {
      return setFilesToMove(files);
    },
    callbackEditFile: function callbackEditFile(file) {
      return setFileToEdit(file);
    },
    callbackOverrideFile: function callbackOverrideFile(file) {
      return setFileToOverride(file);
    },
    setSelectedPath: setSelectedPath,
    selectedPath: selectedPath,
    selectedRows: selectedRows,
    setSelectedRows: setSelectedRows
  })), tasks.length > 0 && /*#__PURE__*/_react["default"].createElement(_BackgroundContainer["default"], {
    tasks: tasks,
    onDismissTask: function onDismissTask(taskId) {
      removeBackgroundTask(taskId);
      refetch();
    },
    callbackRefetch: function callbackRefetch() {
      var now = new Date();
      var timeDiff = now.getTime() - lastRefetchTime.getTime();
      if (timeDiff >= 10000) {
        // 10 seconds on milisegundos
        setLastRefetchTime(now);
        refetch();
      }
    }
  })), /*#__PURE__*/_react["default"].createElement(_Alerts.Alerts, {
    alertOpen: alertMessage !== "",
    color: alertColor,
    message: alertMessage,
    handleAlertClose: function handleAlertClose() {
      return setAlertMessage("");
    }
  }), showUploadFilesModal && documents && /*#__PURE__*/_react["default"].createElement(_UploadFile.UploadFileModal, {
    showModal: showUploadFilesModal,
    selectedPath: selectedPath,
    documents: showUploadFilesModal === "create_folder" ? documents : documents.filter(function (d) {
      var path = selectedPath.length > 0 ? selectedPath.map(function (p) {
        return p.name;
      }).join("/") + "/" : "";
      return d.path === path;
    }),
    callbackClose: function callbackClose(updateFiles, _numFiles) {
      setShowUploadFilesModal(null);
      if (updateFiles) {
        setSelectedRows([]);
        refetch();
      }
    }
  }), filesToDelete.length > 0 && /*#__PURE__*/_react["default"].createElement(_DeleteModal.DeleteModal, {
    documents: filesToDelete,
    selectedRows: selectedRows.length > 0 ? selectedRows : filesToDelete,
    callbackClose: function callbackClose(update) {
      setFilesToDelete([]);
      if (update) {
        setAlertMessage("You have successfully deleted selected file(s).");
        setAlertColor(_constants.AlertColor.Success);
        setSelectedRows([]);
        refetch();
      }
    }
  }), filesToMove.length > 0 && /*#__PURE__*/_react["default"].createElement(_MoveModal.MoveModal, {
    currentPath: selectedPath,
    selectedDocuments: filesToMove,
    availableFolders: documents,
    callbackClose: function callbackClose(update) {
      setFilesToMove([]);
      if (update) {
        setAlertMessage("You have successfully move selected item(s).");
        setAlertColor(_constants.AlertColor.Success);
        setSelectedRows([]);
        refetch();
      }
    }
  }), fileToEdit && /*#__PURE__*/_react["default"].createElement(_EditModal.EditModal, {
    documents: documents,
    selectedPath: selectedPath,
    callbackClose: function callbackClose(fileEdited) {
      setFileToEdit(null);
      if (fileEdited) {
        setAlertMessage("You have successfully edited selected file(s).");
        setAlertColor(_constants.AlertColor.Success);
        refetch();
        editFileLocalStorage(fileEdited);
      }
    },
    file: fileToEdit
  }), fileToOverride && /*#__PURE__*/_react["default"].createElement(_OverrideModal.OverrideModal, {
    callbackClose: function callbackClose(fileEdited) {
      setFileToOverride(null);
      if (fileEdited) {
        setAlertMessage("You have successfully overrided selected file.");
        setAlertColor(_constants.AlertColor.Success);
        refetch();
        editFileLocalStorage(fileEdited);
      }
    },
    file: fileToOverride
  }), openTeamsIntegrationModal && /*#__PURE__*/_react["default"].createElement(_TeamsIntegrationModal.TeamsIntegrationModal, {
    documents: (documents === null || documents === void 0 ? void 0 : documents.filter(function (d) {
      return d.folderSource === _constants.TEAMS_SOURCE;
    })) || [],
    callbackClose: function callbackClose(_message, _color) {
      if (_message && _color) {
        setAlertColor(_color);
        if (_color === _constants.AlertColor.Success) {
          setOpenTeamsIntegrationModal(false);
          refetch();
        } else {
          setAlertMessage(_message);
        }
      } else {
        setOpenTeamsIntegrationModal(false);
      }
    }
  }));
};